import { ThemeProvider } from '@material-ui/styles';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import Init from './config/Init';
import Store from './config/store';
import WholemeaningDefaultTheme from './config/styles/WholemeaningDefaultTheme';
import Application from './screens/Application/components/Application';
import * as serviceWorker from './serviceWorker';

export const application = (
  <ThemeProvider theme={WholemeaningDefaultTheme}>
    <Provider store={Store}>
      <I18nextProvider i18n={i18next}>
        <Application />
      </I18nextProvider>
    </Provider>
  </ThemeProvider>
);

// tslint:disable-next-line: no-expression-statement
Init();

// tslint:disable-next-line: no-expression-statement
render(application, window.document.querySelector('application-root') as HTMLElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

// tslint:disable-next-line: no-expression-statement
serviceWorker.unregister();
